
  <mat-form-field class="mat-form-field date" appearance="">
    <input
      matInput
      style="top: 0.5px; position: relative"
      [matDatepicker]="picker"
      [min]="dayLimit"
      [max]="maxDate"
      [attr.opens]="opens"
      [(ngModel)]="selectedDate"
      (dateChange)="dateChangd()"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"  style="position: relative; left: 7px; top: 0px;"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
